import { validationSchema } from "../multichannel/validationSchema";
import * as Yup from "yup";

export const schema = Yup.object({
  id_customer: Yup.string().required("El cliente es requerido"),
  partner: Yup.string().required("El partner es requerido"),
});

export const validationSchemaAdmin = schema.concat(validationSchema);
